module.exports = __webpack_public_path__ + "static/img/fivelogo.99c2078.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fivelogo.png
// module id = fEJ3
// module chunks = 175